import { Routes, Route, Navigate } from 'react-router-dom'
import Login from './pages/auth/Login'
import Register from './pages/auth/Register'
import ForgotPassword from './pages/auth/ForgotPassword'
import ResetPassword from './pages/auth/ResetPassword'
import Overview from './pages/dashboard/Overview'
import ApiKeys from './pages/dashboard/ApiKeys'
import Transactions from './pages/dashboard/Transactions'
import TransactionDetail from './pages/dashboard/TransactionDetail'
import Webhooks from './pages/dashboard/Webhooks'
import Settings from './pages/dashboard/Settings'
import StaticAddresses from './pages/dashboard/StaticAddresses'

function App() {
  return (
    <div className="min-h-screen bg-background">
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/dashboard" element={<Overview />} />
        <Route path="/dashboard/api-keys" element={<ApiKeys />} />
        <Route path="/dashboard/transactions" element={<Transactions />} />
        <Route path="/dashboard/transactions/:id" element={<TransactionDetail />} />
        <Route path="/dashboard/webhooks" element={<Webhooks />} />
        <Route path="/dashboard/static-addresses" element={<StaticAddresses />} />
        <Route path="/dashboard/settings" element={<Settings />} />
      </Routes>
    </div>
  )
}

export default App
